<template>
    <div class="entryBody">
        <TransitionEffect
            v-if="!loading"
            name="simpleFade"
            :appear="true">
            <BlurredBackground
                :image="blurredImage"/>
        </TransitionEffect>
        <MainContent
            :loading="loading"
            :reachedBottom="allEntriesReachedBottom"
            @handleView="handleView">
            <template slot="leadingItem">
                <BlurCapImage class="leading"
                    v-if="!loading"
                    badgeType="recent"
                    :badgeLabel="siteContent.recentlyPublished"
                    :routerLink="'/entry/' + entries.leading.id"
                    :carousel="entries.leading.media.carousel"
                    :image="leadingImage"
                    :slider="sliderImage"
                    :position="leadingImagePosition"
                    :sensitive="entries.leading.flag.sensitive">
                    <EntryDetail
                        :entry="entries.leading"/>
                </BlurCapImage>
            </template>
            <template slot="feed">
                <EntryFeed
                    v-if="!loading"
                    :entries="entries.regular"/>
            </template>
        </MainContent>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    
    import MainContent from  '@/components/layout/main/MainContent'
    import EntryDetail from  '@/components/journal/main/EntryDetail'
    import EntryFeed from    '@/components/journal/main/EntryFeed'

    export default {
        name: 'AllEntries',
        components: {
            MainContent,
            EntryDetail,
            EntryFeed
        },
        data() {
            return {
                loading: true,
            }
        },
        computed: {
            ...mapState('journal',['allEntries','allEntriesReachedBottom']),
            
            entries() {
                var regularEntries = this.allEntries.slice(1, this.allEntries.length)
                var leadingEntry   = this.allEntries[0]

                var entries = {
                    regular: regularEntries,
                    leading: leadingEntry
                }
                
                return entries
            },
            lastVisible() {
                return this.allEntries[this.allEntries.length - 1]
            },
            leadingImage() {
                if(this.entries.leading.media.carousel) {
                    return this.entries.leading.media.carousel[0].url
                } else if(this.entries.leading.media.slider) {
                    return this.entries.leading.media.slider.right.url
                }
            },
            sliderImage() {
                if(this.entries.leading.media.slider) {
                    return { 
                        left:  this.entries.leading.media.slider.left.url,
                        right: this.entries.leading.media.slider.right.url,
                    }
                } else {
                    return
                }
            },
            blurredImage() {
                if(this.entries.leading.media.carousel) {
                    return this.entries.leading.media.carousel[0].url
                } else if(this.entries.leading.media.slider) {
                    return this.entries.leading.media.slider.right.url
                }
            },
            leadingImagePosition() {
                if(this.entries.leading.media.carousel) {
                    return this.entries.leading.media.carousel[0].position
                } else if(this.entries.leading.media.slider) {
                    return this.entries.leading.media.slider.left.position
                } else {
                    return
                }
            }
        },
        async mounted() {
            if(this.allEntries.length === 0) {
                this.loadFeed()
            } else {
                this.loading = false
            }
        },
        methods: {
            ...mapActions('journal',['fetchEntries','fetchEntriesAfter']),
            
            async loadFeed() {
                try {
                    await this.fetchEntries({
                        commitName:    'setAllEntries',
                        feedType:      'allEntries',
                        limit:          3
                    })
                    this.loading = false
                } catch(e) {
                    throw e
                }
            },
            async handleView() {
                await this.fetchEntriesAfter({
                    commitName:         'addAllEntries',
                    feedType:           'allEntries',
                    lastVisible:         this.lastVisible,
                    limit:               2
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .entryBody {
        position: relative;
        display: flex;
        width: 100%;
    }
</style>